import toast from 'react-hot-toast';
import React, { useCallback, useEffect } from 'react';
import { useSocketIOContext } from '../components/SocketIOContext';
import {useGameStore} from "../store";

type ErrorMessage = {
  error?: string;
};

export const useErrorListener = () => {
  const { setBattleError } = useGameStore();
  const { socket } = useSocketIOContext();

  const handleError = useCallback((data: ErrorMessage) => {
    if (data && data.error) {
      if(data.error == "No health"){
        setBattleError(data.error);
      }
      toast.error(`Error: ${data.error}`, {
        style: {
          borderRadius: '30px',
          background: '#090e1de3',
          color: '#fff',
          padding: '1rem 2rem',
        },
      });
    }
  }, []);

  useEffect(() => {
    if (!socket) return;
    socket.on('ERROR', handleError);

    return () => {
      socket.off('ERROR', handleError);
    };
  }, [socket, handleError]);
};
